
<template>
  <v-layout justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-form ref="changePasswordForm" autocomplete="off">
        <v-card>
          <v-card-title>
            <span class="headline">CHANGE MY PASSWORD</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    ref="password"
                    v-model="dialogChangePasswordItem.password"
                    :rules="requiredField"
                    :type="showChangeCurrentField ? 'text' : 'password'"
                    :append-icon="
                      showChangeCurrentField ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    label="Current Password"
                    placeholder="Current Password"
                    @click:append="
                      showChangeCurrentField = !showChangeCurrentField
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    ref="password"
                    v-model="dialogChangePasswordItem.newPassword"
                    :type="showChangeNewPassordField ? 'text' : 'password'"
                    :rules="[rules.password]"
                    :append-icon="
                      showChangeNewPassordField ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    label="New Password"
                    placeholder="New Password"
                    @click:append="
                      showChangeNewPassordField = !showChangeNewPassordField
                    "
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    ref="confirmNewPassword"
                    v-model="dialogChangePasswordItem.confirmNewPassword"
                    :type="
                      showChangeConfirmNewPassordField ? 'text' : 'password'
                    "
                    :rules="[rules.password, passwordConfirmationRule]"
                    :append-icon="
                      showChangeConfirmNewPassordField
                        ? 'mdi-eye'
                        : 'mdi-eye-off'
                    "
                    label="Confirm New Password"
                    placeholder=" Confirm New Password"
                    @click:append="
                      showChangeConfirmNewPassordField = !showChangeConfirmNewPassordField
                    "
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    ref="pin"
                    v-model="dialogChangePasswordItem.pin"
                    :type="showChangePinField ? 'text' : 'password'"
                    :rules="[rules.pinValidation, rules.characterCountValidation,rules.onlyNumbersValidation]"
                    :append-icon="showChangePinField ? 'mdi-eye' : 'mdi-eye-off'"
                    label="PIN"
                    placeholder="PIN"
                    @click:append="showChangePinField = !showChangePinField"
                  ></v-text-field>
                </v-col> -->
              </v-row>
            </v-container>
            <!-- <small>*indicates required field</small> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="gobackBtn()">BACK</v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateChangePasswordItem()"
              >update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>

      <div class="text-center">
        <!-- <v-btn dark color="orange darken-2" @click="snackbar = true">Open Snackbar</v-btn> -->
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          color="success"
          :top="y === 'top'"
        >
          {{ text }}
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
              >Close</v-btn
            >
          </template>
        </v-snackbar>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
//import axios from 'axios';
/* eslint-disable no-debugger */
export default {
  name: "app",
  data() {
    {
      return {
        // username: "",
        // password: "",
        dialogChangePasswordItem: {
          userId: "",
          pin: "",
          newPassword: "",
          confirmNewPassword: "",
          password: "",
        },
        show2: false,
        showChangePinField: false,
        showChangeNewPassordField: false,
        showChangeCurrentField: false,
        showChangeConfirmNewPassordField: false,
        rules: {
          password: (value) => {
            const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/;
            return (
              pattern.test(value) ||
              "Min. 8 characters with at least one capital letter, a number and a special character."
            );
          },
          pinValidation: (value) => {
            return !!value || "This field is required";
          },
          characterCountValidation: (v) => {
            return v.length == 4 || "Must contain 4 digits";
          },
          onlyNumbersValidation: (value) => {
            const pattern = /^(^[0-9]*$)/;
            return pattern.test(value) || "Only numbers";
          },
        },
        requiredField: [
          (v) => !!v || "This field is required",
          (v) => v.length >= 3 || "Minimum length is 3 characters",
        ],
        snackbar: false,
        text: "PASSWORD CHANGED",
        timeout: 4000,
        y: "top",
      };
    }
  },
  methods: {
    gobackBtn() {
      console.log("gobackBtn");
    if (this.$store.getters.getNeedToChangePassword != true) {
      this.$router.go(-1);
    }
      
    },
    updateChangePasswordItem() {
      //OID10002
      if (this.$refs.changePasswordForm.validate()) {
        this.dialogChangePasswordItem.userId = this.$store.getters.getUserId;
        console.log(this.dialogChangePasswordItem);
        this.$http
          .post(
            this.$store.getters.getBaseUrl + "changeMyPassword",
            this.dialogChangePasswordItem
          )
          .then(() => {
            // debugger;
            // console.log("processed");
            // this.snackbar = true;
            // this.dialogChangePasswordItem = {
            //   userId: "",
            //   pin: "",
            //   newPassword: "",
            //   password: "",
            // };
            alert("PASSWORD CHANGED");
            this.$store.commit("setNeedToChangePassword", false);
            this.$store.commit("setMenuAsEnabled");
            this.$router.push({ name: "Home" });
          })
          .catch(function (error) {
            console.log("error " + error);
            alert("error " + error.response.data);
          });
      }
    },
  },
  mounted() {
    //OID10002
    // this.$http
    //   .get(
    //     this.$store.getters.getBaseUrl +
    //       "changePassword/?userId=" +
    //       this.$store.getters.getUserId
    //   )
    //   .then((result) => {
    //     result.data.newPassword = ""
    //     result.data.confirmNewPassword = ""
    //     result.data.password = ""
    //     this.dialogChangePasswordItem = result.data
    //   })
    //   .catch(function (error) {
    //     console.log("error " + error);
    //     alert("error" + error.response.data);
    //   });

    if (this.$store.getters.getNeedToChangePassword == true) {
      this.$store.commit("setMenuAsDisabled");
    }
  },
  computed: {
    passwordConfirmationRule() {
      return () =>
        this.dialogChangePasswordItem.newPassword ===
          this.dialogChangePasswordItem.confirmNewPassword ||
        "New password must match";
    },
  },
};
</script>

<style>
</style>
